var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-fill" },
    [
      _c(
        "b-card",
        {
          ref: "card",
          staticClass: "flex-fill",
          attrs: { "header-bg-variant": "primary" },
          scopedSlots: _vm._u(
            [
              {
                key: "header",
                fn: function () {
                  return [
                    _vm._t("card-header", function () {
                      return [
                        _vm._v("\n        " + _vm._s(_vm.header) + "\n      "),
                      ]
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _c(
            "b-list-group",
            { staticClass: "flex-fill d-flex flex-column" },
            [
              !!_vm.$slots["header"]
                ? _c(
                    "b-list-group-item",
                    { staticClass: "header" },
                    [_vm._t("header")],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-list-group-item",
                {
                  ref: "content",
                  staticClass: "content-scroll flex-fill no-margin no-padding",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showContent,
                          expression: "showContent",
                        },
                      ],
                      staticClass: "content",
                    },
                    [_vm._t("content")],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              !!_vm.$slots["footer"]
                ? _c(
                    "b-list-group-item",
                    { staticClass: "p-0" },
                    [_vm._t("footer")],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }